import React, { VFC } from 'react';
import ToyonoComponent from '~/src/feature/toyono/components';
import { HeaderProps, BusinessProps } from '~/src/feature/toyono/types';
import AuthDialogContextProvider from '~/src/front/components/AuthDialog/AuthDialogContextProvider';
import type { CardProps } from '../../front/Plans/Card';

type Props = HeaderProps & {
  authenticated: boolean;
  businesses: Array<BusinessProps>;
  plans: Array<CardProps>;
};

const Toyono: VFC<Props> = ({
  authenticated,
  businesses,
  plans,
  ...headerProps
}: Props) => {
  return (
    <AuthDialogContextProvider>
      <ToyonoComponent
        authenticated={authenticated}
        businesses={businesses}
        plans={plans}
        headerProps={headerProps}
      />
    </AuthDialogContextProvider>
  );
};

export default Toyono;
